import i18n from '@geek/yum-freight-framework/src/lang/index'
import store from '@geek/yum-freight-framework/src/store'
import Vue from 'vue'
import { isGoFreightUser } from '@/utils/goFreight'
import zh_CN from './locales/zh_CN'
import en from './locales/en'

const projectLocales = { zh_CN, en }
const CHINESE_NAME_TITLE_KEY = 'chineseNameTitle'
const GO_FREIGHT_LOCAL_NAME = 'Local Name'

function patchGoFreightMsg(msg, locale) {
  if (!msg || !isGoFreightUser()) return msg
  if (locale !== 'en') return msg
  return {
    ...msg,
    [CHINESE_NAME_TITLE_KEY]: GO_FREIGHT_LOCAL_NAME
  }
}

function withProjectMsg(locale, message) {
  const localeMessages = projectLocales[locale]
  if (!localeMessages || !message || typeof message !== 'object') {
    return message
  }
  return {
    ...message,
    msg: patchGoFreightMsg(
      { ...(message.msg || {}), ...localeMessages },
      locale
    )
  }
}

function applyGoFreightI18nPatch() {
  if (!isGoFreightUser()) return
  ;['en', 'zh_CN'].forEach((locale) => {
    const localeMessage = i18n.getLocaleMessage(locale) || {}
    i18n.mergeLocaleMessage(locale, {
      msg: patchGoFreightMsg(localeMessage.msg || {}, locale)
    })
  })
  Vue.prototype.$eventBus.$emit('go-freight-permission-updated')
}

let originalSetLocaleMessage = null
let originalT = null
let storeSubscribed = false

export function initProjectI18n() {
  if (!originalT) {
    originalT = i18n.t.bind(i18n)
    i18n.t = (key, ...args) => {
      if (!isGoFreightUser()) {
        return originalT(key, ...args)
      }
      if (key === `msg.${CHINESE_NAME_TITLE_KEY}` && i18n.locale === 'en') {
        return GO_FREIGHT_LOCAL_NAME
      }
      return originalT(key, ...args)
    }
  }

  if (!originalSetLocaleMessage) {
    originalSetLocaleMessage = i18n.setLocaleMessage.bind(i18n)
    i18n.setLocaleMessage = (locale, message) => {
      originalSetLocaleMessage(locale, withProjectMsg(locale, message))
      applyGoFreightI18nPatch()
    }
  }

  Object.keys(projectLocales).forEach((code) => {
    const current = i18n.getLocaleMessage(code) || {}
    i18n.setLocaleMessage(code, current)
  })

  if (!storeSubscribed) {
    storeSubscribed = true
    store.subscribe((mutation) => {
      if (mutation.type === 'permission/SET_FUNCTIONLIST') {
        applyGoFreightI18nPatch()
      }
    })
  }

  applyGoFreightI18nPatch()
}

export { i18n }
